const removeQuotesFromJSONString = (jsonString) => jsonString.replace(/\"([^(\")"]+)\":/g, '$1:')
const jsonStringifyForGraphQL = (jsonObject) => {
  const jsonString = JSON.stringify(jsonObject)
  return removeQuotesFromJSONString(jsonString)
}

export {
  removeQuotesFromJSONString,
  jsonStringifyForGraphQL
}



// WEBPACK FOOTER //
// ./src/utilities.js